import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  getSeason: false,
  getTeams: false,
  getGames: false,
  updatePlayerVerifiedTeams: false,
  updateSeason: false,
  createGame: false,
  createBasicSeason: false,
  createPremiumSeason: false,
};

const Season = {
  getSeason: ({ seasonUniqid }) => {
    if (debugStatus.getSeason) {
      return fakeApiHelper(200, 'success', {
        data: {
          auto_game_seq: true,
          config: {
            open_registration: false,
            player_registration: {},
          },
          description: '',
          end_at: '2020-07-23T23:59:59+08:00',
          league: {
            name: 'OOOO',
            uniqid: 'zxcv',
          },
          start_at: '2020-07-15T00:00:00+08:00',
          title: '2020 OOOO',
          type: 'CUP_MATCHES',
          uniqid: 'zxcv-2020-XX',
          year: 2020,
        },
        error: false,
        message: 'Get season successfully',
      });
    }

    return ApiService.get(`/api/seasons/${seasonUniqid}`);
  },

  getTeams: ({ seasonUniqid }) => {
    if (debugStatus.getTeams) {
      return fakeApiHelper(200, 'success', {
        data: [
          {
            name: 'AAAC',
            origin: {
              icon_url: '',
              name: 'AAA',
              uniqid: 'wxyz',
            },
            season: {
              title: '2020 OOOO',
              uniqid: 'wasd',
            },
          },
          {
            name: 'BBBB',
            origin: {
              icon_url: '',
              name: 'BBBB',
              uniqid: 'zyxw',
            },
            season: {
              title: '2020 OOOO',
              uniqid: 'wasd',
            },
          },
        ],
        error: false,
        message: 'Get season teams successfully',
      });
    }

    return ApiService.get(`/api/seasons/${seasonUniqid}/teams`);
  },

  getGames: ({ seasonUniqid }) => {
    return ApiService.get(`/api/seasons/${seasonUniqid}/games`);
  },

  deleteGame: ({ seasonUniqid, gameUniqid }) => {
    return ApiService.delete(`/api/seasons/${seasonUniqid}/games/${gameUniqid}`);
  },

  getGroups: ({ seasonUniqid }) => {
    return ApiService.get(`/api/seasons/${seasonUniqid}/groups`);
  },

  createGroup: ({ seasonUniqid, data }) => {
    return ApiService.post(`/api/seasons/${seasonUniqid}/groups`, { data });
  },

  updateGroup: ({ seasonUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/groups`, { data });
  },

  deleteGroup: ({ seasonUniqid, groupName }) => {
    return ApiService.delete(`/api/seasons/${seasonUniqid}/groups/${encodeURIComponent(groupName)}`);
  },

  updatePlayerVerifiedTeams: ({ seasonUniqid, data }) => {
    if (debugStatus.updatePlayerVerifiedTeams) {
      return fakeApiHelper(200, 'success', {
        data: {
          auto_game_seq: true,
          config: {
            open_registration: true,
            player_registration: {},
            player_verified_teams: {
              '臺北市 OO高中': {
                last_verified_at: '2021/03/25 05:06:20',
                status: 'VERIFIED',
                team_name: '臺北市 OO高中',
              },
            },
          },
          description: '',
          end_at: null,
          league: { name: 'OOOOO', uniqid: 'nH8l' },
          start_at: '2021-06-06T00:00:00+08:00',
          title: '2021 OOO XXX',
          type: 'CUP_MATCHES',
          uniqid: 'nH8l-2021-xx',
          year: 2021,
        },
        error: false,
        message: 'Update player verified teams successfully',
      });
    }

    return ApiService.put(`/api/seasons/${seasonUniqid}/player_verified_teams`, { data });
  },

  updateSeason: ({ leagueUniqid, seasonUniqid, data }) => {
    return ApiService.put(`/api/leagues/${leagueUniqid}/seasons/${seasonUniqid}`, { data });
  },

  updateSeasonBasic: ({ leagueUniqid, seasonUniqid, data }) => {
    return ApiService.put(`/api/leagues/${leagueUniqid}/seasons/${seasonUniqid}/basic`, { data });
  },

  createGame: ({ seasonUniqid, data }) => {
    return ApiService.post(`/api/seasons/${seasonUniqid}/games`, { data });
  },

  importTournamentTeamByOrganizer: ({ seasonUniqid, data }) => {
    return ApiService.post(`/api/seasons/${seasonUniqid}/teams/import`, { data });
  },

  createTournamentTeamByOrganizer: ({ seasonUniqid, data }) => {
    return ApiService.post(`/api/seasons/${seasonUniqid}/teams`, { data });
  },

  unregisterTournamentTeamByOrganizer: ({ seasonUniqid, seasonTeamUniqid }) => {
    return ApiService.delete(`/api/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}`);
  },

  updateTournamentTeamByOrganizer: ({ seasonUniqid, seasonTeamUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}`, { data });
  },

  createBasicSeason: ({ leagueUniqid, data }) => {
    return ApiService.post(`/api/leagues/${leagueUniqid}/basic_seasons`, { data });
  },

  createPremiumSeason: ({ leagueUniqid, data }) => {
    return ApiService.post(`/api/leagues/${leagueUniqid}/premium_seasons`, { data });
  },

  downloadSeasonExcel: ({ seasonUniqid }) => {
    return new Promise((resolve, reject) => {
      ApiService.refreshToken()
        .then(() =>
          resolve(
            ApiService.get(`/api/seasons/${seasonUniqid}/excel`, {
              preprocess: false,
              responseType: 'blob',
              timeout: 0,
            }),
          ),
        )
        .catch(reject);
    });
  },
};

export default Season;
